import { Emitter } from "@/lib/emitter"

export const routeChangeEmitter = new Emitter<string>()
